export const styles = {
  failedOrdersTable: {
    '.MuiTableRow-root td': {
      verticalAlign: 'middle',
    },
  },
};
